import { render, staticRenderFns } from "./SignContractDisputeProtocolPopup.view.vue?vue&type=template&id=c316cee0&"
import script from "./SignContractDisputeProtocolPopup.view.vue?vue&type=script&lang=js&"
export * from "./SignContractDisputeProtocolPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c316cee0')) {
      api.createRecord('c316cee0', component.options)
    } else {
      api.reload('c316cee0', component.options)
    }
    module.hot.accept("./SignContractDisputeProtocolPopup.view.vue?vue&type=template&id=c316cee0&", function () {
      api.rerender('c316cee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/disputes/protocol/sign/SignContractDisputeProtocolPopup.view.vue"
export default component.exports